(function() {

  angular.module('EnumerationProvider', [])

  .factory('EnumerationModel', ['$q', '$http', function( $q, $http) {
    return function(data) {
      var BoilerPlateModel = {};



      return BoilerPlateModel;
    }
  }])

  .service('EnumerationService', ['EnvironmentService', '$http', '$q',
    function(EnvironmentService, $http, $q) {

      var enumsServiceObject = this;
      this.enums;

      this.resolveEnumerations = function() {
        var deferred = $q.defer();
        var enumURL = EnvironmentService.apiBaseUrl + '/v1/enumerations';
        $http.get(enumURL).then(function(response) {
          enumsServiceObject.rawEnums = response.data._embedded.enumerations;
          enumsServiceObject.enums = mapEnums(response.data._embedded.enumerations);
          deferred.resolve(enumsServiceObject.enums);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      function mapEnums (enumerations) {
        var enumerationsObject = {};
        angular.forEach(enumerations, function(enumeration) {
          enumerationsObject[enumeration.name] = [];
          angular.forEach(enumeration.values, function(enumerationValue){
            var enumerationObject = {
              id: enumerationValue,
              name: enumerationValue,
              key: enumerationValue,
              value: enumerationValue,
            }
            enumerationsObject[enumeration.name].push(enumerationObject);
          })
        });

        for (var key in enumerationsObject) {
          enumerationsObject[key].sort( compare );
        }

        return enumerationsObject;
      }

      function compare( a, b ) {
        if ( a.name < b.name ){
          return -1;
        }
        if ( a.name > b.name ){
          return 1;
        }
        return 0;
      }


    }
  ])

})();